export const bucketlistConstants = {
  ///CREATE BUCKETLIST
  CREATE_BUCKET_LIST_DATA_ACTION_REQUEST:
    "CREATE_BUCKET_LIST_DATA_ACTION_REQUEST",
  CREATE_BUCKET_LIST_DATA_ACTION_SUCCESS:
    "CREATE_BUCKET_LIST_DATA_ACTION_SUCCESS",
  CREATE_BUCKET_LIST_DATA_ACTION_FAILURE:
    "CREATE_BUCKET_LIST_DATA_ACTION_FAILURE",

  //DELETE BUCKETLIST
  DELETE_BUCKET_LIST_DATA_ACTION_REQUEST:
    "DELETE_BUCKET_LIST_DATA_ACTION_REQUEST",
  DELETE_BUCKET_LIST_DATA_ACTION_SUCCESS:
    "DELETE_BUCKET_LIST_DATA_ACTION_SUCCESS",
  DELETE_BUCKET_LIST_DATA_ACTION_FAILURE:
    "DELETE_BUCKET_LIST_DATA_ACTION_FAILURE",

  //GET ALL BUCKETLIST
  GET_ALL_BUCKET_LIST_DATA_ACTION_REQUEST:
    "GET_ALL_BUCKET_LIST_DATA_ACTION_REQUEST",
  GET_ALL_BUCKET_LIST_DATA_ACTION_SUCCESS:
    "GET_ALL_BUCKET_LIST_DATA_ACTION_SUCCESS",
  GET_ALL_BUCKET_LIST_DATA_ACTION_FAILURE:
    "GET_ALL_BUCKET_LIST_DATA_ACTION_FAILURE",

  //ASSIGN INTERVIEW TO BUCKETLIST
  ASSIGN_INTERVIEW_TO_BUCKET_LIST_DATA_ACTION_REQUEST:
    "ASSIGN_INTERVIEW_TO_BUCKET_LIST_DATA_ACTION_REQUEST",
  ASSIGN_INTERVIEW_TO_BUCKET_LIST_DATA_ACTION_SUCCESS:
    "ASSIGN_INTERVIEW_TO_BUCKET_LIST_DATA_ACTION_SUCCESS",
  ASSIGN_INTERVIEW_TO_BUCKET_LIST_DATA_ACTION_FAILURE:
    "ASSIGN_INTERVIEW_TO_BUCKET_LIST_DATA_ACTION_FAILURE",

  //GET ALL BUCKETLIST data by id
  GET_BUCKET_LIST_DATA_BY_ID_ACTION_REQUEST:
    "GET_BUCKET_LIST_DATA_BY_ID_ACTION_REQUEST",
  GET_BUCKET_LIST_DATA_BY_ID_ACTION_SUCCESS:
    "GET_BUCKET_LIST_DATA_BY_ID_ACTION_SUCCESS",
  GET_BUCKET_LIST_DATA_BY_ID_ACTION_FAILURE:
    "GET_BUCKET_LIST_DATA_BY_ID_ACTION_FAILURE",

  //GET all candidates of bucket list

  GET_BUCKET_LIST_CANDIDATES_DATA_ACTION_REQUEST:
    "GET_BUCKET_LIST_CANDIDATES_DATA_ACTION_REQUEST",
  GET_BUCKET_LIST_CANDIDATES_DATA_ACTION_SUCCESS:
    "GET_BUCKET_LIST_CANDIDATES_DATA_ACTION_SUCCESS",
  GET_BUCKET_LIST_CANDIDATES_DATA_ACTION_FAILURE:
    "GET_BUCKET_LIST_CANDIDATES_DATA_ACTION_FAILURE",

  //GET all candidates of bucket list

  SEND_BUCKET_BY_EMAIL_DATA_ACTION_REQUEST:
    "SEND_BUCKET_BY_EMAIL_DATA_ACTION_REQUEST",
  SEND_BUCKET_BY_EMAIL_DATA_ACTION_SUCCESS:
    "SEND_BUCKET_BY_EMAIL_DATA_ACTION_SUCCESS",
  SEND_BUCKET_BY_EMAIL_DATA_ACTION_FAILURE:
    "SEND_BUCKET_BY_EMAIL_DATA_ACTION_FAILURE",
};
